import React, {useRef, useEffect, useState } from 'react';

function SlideVideo(props) {
  const ref = useRef(null);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(-1);
  const sensibility = 50;

  function handleTouchEnd(ev) {
    if (touchEnd < 0)
      // just clicked on the div
      return;
    let delta = touchEnd - touchStart;
    //console.log("Touch: Start "+touchStart + ", End "+ touchEnd + ", Delta = "+delta)
    if (delta > sensibility) {
      // swipe to right
      props.prevSlide();
    }
    if (delta < (-sensibility)) {
      // swipe to left
       props.nextSlide();
    }
    setTouchEnd(-1);
  }
/*
  function cssClass() {
    let cssClass = props.img? "AW-imageSlides w3-animate-fading" : "AW-imageSlides w3-animate-fading AW-video";
    if (props.active === true)
      cssClass += " attiva";
    return cssClass;        
  }
*/
  useEffect(() => {
    if (!props.desktopMode)
      return;
    //console.log("SlideImage: useEffect - "+props.idx)
    if (props.active) {
        //console.log("useEffect() "+props.idx);
        if (props.idx > 0)
          ref.current.scrollIntoView({ behavior: "smooth", block : "center", inline : "nearest" });
        else 
          //ref.current.scrollIntoView({ behavior: "smooth", block : "start", inline : "nearest" });
          window.scroll({top: 0, left: 0, behavior: 'smooth'});
     }
  }, [props.active, props.desktopMode, props.idx]);

  if (props.desktopMode)
    // versione desktop (touch disabled, zoom on click)
    return (
      <div
        className={
          props.active === true
            ? "AW-imageSlides AW-video w3-animate-fading attiva"
            : "AW-imageSlides AW-video w3-animate-fading"
        }
        ref={ref}
        idx={props.idx}
        onClick={(e) => props.clickHandler(e, props.idx)}
      >
       <iframe 
          title={props.title.length > 0 ? props.title : "vid_"+props.idx}
          width='100%' 
          height='100%' 
          src={props.filename+"?html5=1&wmode=transparent&showinfo=0&rel=0&origin="+props.urlBase}
          allowFullScreen 
          frameBorder='0'/>
        
      </div>
    );
  else
    // versione mobile (touch enabled, no zoom on click)
    return (
      <div
        className={
          props.active === true
            ? "AW-imageSlides AW-video w3-animate-fading attiva"
            : "AW-imageSlides AW-video w3-animate-fading"
        }
        ref={ref}
        idx={props.idx}
        onTouchStart={(e) => setTouchStart(e.targetTouches[0].clientX)}
        onTouchMove={(e) => setTouchEnd(e.targetTouches[0].clientX)}
        onTouchEnd={(e) => handleTouchEnd(e)}
      >
        <iframe 
          title={props.title.length > 0 ? props.title : "vid_"+props.idx}
          width='100%' 
          height='100%' 
          src={props.filename+"?html5=1&wmode=transparent&showinfo=0&rel=0&origin="+props.urlBase}
          allowFullScreen 
          frameBorder='0'/>
      </div>
    );

}

export default SlideVideo;